import { Component } from '@angular/core';
import { AnimatedLoaderType } from 'src/app/shared/models/animated-loader-type.enum';

@Component({
  selector: 'app-application-loading-component',
  templateUrl: './application-loading-component.component.html',
  styleUrls: ['./application-loading-component.component.css'],
})
export class ApplicationLoadingComponentComponent {
  animatedLoaderType = AnimatedLoaderType;
}
